import { AudioProcessingIntervalType } from '@account_module/types/AudioProcessing';

export const PROCESSING_INTERVAL = {
  DAY: 'day' as AudioProcessingIntervalType,
  WEEK: 'week' as AudioProcessingIntervalType,
  MONTH: 'month' as AudioProcessingIntervalType,
  YEAR: 'year' as AudioProcessingIntervalType,
};
